import { type ElementType, type PropsWithChildren, forwardRef } from "react";
import Classes from "./DDSDisplayText.module.css";

export type DDSDisplayTextProps = {
  as?: "h1" | "h2" | "h3" | "h4" | "h5";
  /**
   * Display size — matches the `--display-{size}-*` CSS tokens.
   *
   * Renamed in 2026 from numeric levels to t-shirt strings: `1`→`"xl"`, `2`→`"lg"`,
   * `3`→`"md"`, `4`→`"sm"`. See the [type system migration spec](https://linear.app/classdojo/document/type-system-migration-spec-and-codefigma-differences-a635b955ad0a)
   * for the full mapping (Figma may still display legacy "Display/1" style names on stale comps).
   */
  level?: "xl" | "lg" | "md" | "sm";
  className?: string;
};

const LEVEL_TO_CLASS = {
  xl: "displayXl",
  lg: "displayLg",
  md: "displayMd",
  sm: "displaySm",
} as const;

export const DDSDisplayText = forwardRef<HTMLElement, PropsWithChildren<DDSDisplayTextProps>>(
  ({ as: tagName = "h1", level = "xl", className, children }, ref) => {
    const Tag = tagName as ElementType;
    return (
      <Tag ref={ref} className={`${className ?? ""} ${Classes[LEVEL_TO_CLASS[level]]}`}>
        {children}
      </Tag>
    );
  },
);

DDSDisplayText.displayName = "DDSDisplayText";
